import { render, staticRenderFns } from "./bulletin-form.vue?vue&type=template&id=0827465c&scoped=true"
import script from "./bulletin-form.vue?vue&type=script&lang=js"
export * from "./bulletin-form.vue?vue&type=script&lang=js"
import style0 from "./bulletin-form.vue?vue&type=style&index=0&id=0827465c&prod&lang=less&scoped=true"
import style1 from "./bulletin-form.vue?vue&type=style&index=1&id=0827465c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827465c",
  null
  
)

export default component.exports